import { t as SandboxAvailabilityService } from "./sandbox_availability_service-D9qa9DsC.mjs";
import { EmptySandboxAvailabilityService as _EmptySandboxAvailabi } from "./empty.mjs";
import { a as _DefaultSandboxUnsupp, i as SandboxUnsupportedPlatformCheck, n as SandboxMissingDependenciesCheck, o as SandboxDisabledByUserCheck, r as _DefaultSandboxMissin, s as _DefaultSandboxDisabl, t as sandboxFeatureStateContributions } from "./contributions-CfMamR42.mjs";
import { t as SandboxUserConfigLoader } from "./types-BP6ZEIjS.mjs";
import { SandboxUnavailableError } from "./errors.mjs";
import { a as WorkerActionRequestSchema, c as WorkerReadyNotification, i as PlainTextResponseSchema, l as WorkerShutdownNotification, n as ExecuteActionRequest, o as WorkerActionResponseSchema, r as HttpResponseSchema, s as WorkerContextSchema, t as CancelActionNotification } from "./worker_rpc-Di8KN-kG.mjs";
import { createRequire } from "node:module";
import { Injectable, collection, createInterfaceId } from "@gitlab/needle";
import EventEmitter from "events";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { SandboxManager } from "@anthropic-ai/sandbox-runtime";
import { isBunRuntime } from "@gitlab-org/core";
import { ConfigService } from "@gitlab-org/config";
import * as os from "node:os";
import * as path from "node:path";
import { dirname, join } from "node:path";
import { McpStdioCommandTransformer } from "@gitlab-org/ai-configuration";
import { spawn } from "node:child_process";
import { existsSync } from "node:fs";
import { StreamMessageReader, StreamMessageWriter, createMessageConnection } from "vscode-jsonrpc/node.js";
import { SecretRedactor } from "@gitlab-org/secret-redaction";
import { DefaultRpcMessageSender } from "@gitlab-org/rpc-client";
import { SandboxViolations, renderViolation } from "@gitlab-org/workflow-executor/violations";
import { ActionExecutorFactory, DirectActionExecutor } from "@gitlab-org/workflow-executor";
import { WorkflowActionHandler } from "@gitlab-org/workflow-executor/node";
//#region \0rolldown/runtime.js
var __require = /* @__PURE__ */ createRequire(import.meta.url);
//#endregion
//#region src/platform.ts
function detectPlatform() {
	switch (process.platform) {
		case "darwin": return "macos";
		case "linux": return "linux";
		case "win32": return "windows";
		default: return "unsupported";
	}
}
//#endregion
//#region src/desktop_sandbox_availability_service.ts
let _initClass$6;
function _applyDecs$6(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$6(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$6(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$6(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$6(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$6(t) {
	var i = _toPrimitive$6(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$6(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$6(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$6(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const INSTALL_HINTS = {
	bwrap: { default: "apt-get install bubblewrap" },
	socat: { default: "apt-get install socat" },
	ripgrep: {
		macos: "brew install ripgrep",
		default: "apt-get install ripgrep"
	}
};
let _DesktopSandboxAvaila;
(class {
	static {
		[_DesktopSandboxAvaila, _initClass$6] = _applyDecs$6(this, [Injectable(SandboxAvailabilityService, [Logger])], []).c;
	}
	#logger;
	#status;
	#statusEmitter = new EventEmitter();
	constructor(logger) {
		this.#logger = withPrefix(logger, "[SandboxAvailability]");
		this.#status = this.#detect();
		this.#logStatus();
	}
	getStatus() {
		return this.#status;
	}
	async refresh() {
		const next = this.#detect();
		if (statusEquals(this.#status, next)) return;
		this.#status = next;
		this.#logStatus();
		this.#statusEmitter.emit("change", this.#status);
	}
	onStatusChanged(listener) {
		this.#statusEmitter.on("change", listener);
		return { dispose: () => this.#statusEmitter.removeListener("change", listener) };
	}
	#detect() {
		const platform = detectPlatform();
		if (platform === "windows" || platform === "unsupported") return {
			available: false,
			platform,
			reason: "unsupported_platform",
			missingDependencies: []
		};
		try {
			const result = SandboxManager.checkDependencies();
			if (result.errors.length > 0) return {
				available: false,
				platform,
				reason: "missing_dependencies",
				missingDependencies: result.errors.map((error) => {
					const lowerError = error.toLowerCase();
					const matchedKey = Object.keys(INSTALL_HINTS).find((key) => lowerError.includes(key));
					const hints = matchedKey ? INSTALL_HINTS[matchedKey] : void 0;
					return {
						name: error,
						installHint: hints ? hints[platform] ?? hints.default ?? "" : ""
					};
				})
			};
			if (result.warnings.length > 0) for (const warning of result.warnings) this.#logger.warn(`srt dependency warning: ${warning}`);
			return {
				available: true,
				platform,
				provider: "srt",
				providerVersion: this.#detectSrtVersion()
			};
		} catch (error) {
			this.#logger.warn("Sandbox dependency detection failed", error);
			return {
				available: false,
				platform,
				reason: "detection_failed",
				missingDependencies: []
			};
		}
	}
	#detectSrtVersion() {
		try {
			return __require("@anthropic-ai/sandbox-runtime/package.json").version;
		} catch {
			return;
		}
	}
	#logStatus() {
		const status = this.#status;
		if (status.available) this.#logger.info(`Sandbox available: platform=${status.platform}, provider=${status.provider}, version=${status.providerVersion ?? "unknown"}`);
		else {
			const details = status.reason === "missing_dependencies" ? `, missing=[${status.missingDependencies.map((d) => d.name).join(", ")}]` : "";
			this.#logger.info(`Sandbox unavailable: platform=${status.platform}, reason=${status.reason}${details}`);
		}
	}
	static {
		_initClass$6();
	}
});
function statusEquals(a, b) {
	if (a.available !== b.available) return false;
	if (a.platform !== b.platform) return false;
	if (a.available && b.available) return a.provider === b.provider && a.providerVersion === b.providerVersion;
	if (!a.available && !b.available) {
		if (a.reason !== b.reason) return false;
		if (a.missingDependencies.length !== b.missingDependencies.length) return false;
		return a.missingDependencies.every((dep, i) => dep.name === b.missingDependencies[i].name && dep.installHint === b.missingDependencies[i].installHint);
	}
	return false;
}
//#endregion
//#region src/sandbox_config_service.ts
const SandboxConfigService = createInterfaceId("SandboxConfigService");
//#endregion
//#region src/desktop_sandbox_config_service.ts
let _initClass$5;
function _applyDecs$5(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$5(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$5(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$5(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$5(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$5(t) {
	var i = _toPrimitive$5(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$5(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$5(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$5(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const DENY_READ_DEFAULTS = [
	"~/.ssh/",
	"~/.gnupg/",
	"~/.netrc",
	"~/.git-credentials",
	"~/.npmrc",
	"~/.pypirc",
	"~/.docker/config.json",
	"~/.aws/",
	"~/.azure/",
	"~/.kube/config",
	"~/.cargo/credentials.toml",
	"~/.cargo/config.toml",
	"~/.cargo/config",
	"~/.vault-token",
	"~/.sentryclirc",
	"~/.yarnrc.yml",
	"~/.config/",
	"~/.password-store/",
	"~/.local/share/keyrings/",
	"~/.gnome2/keyrings/",
	"~/Documents/",
	"~/Downloads/",
	"~/Desktop/",
	"~/Pictures/",
	"~/Movies/",
	"~/Music/",
	"~/Library/Application Support/",
	"~/Library/Containers/",
	"~/Library/Group Containers/",
	"~/Library/Keychains/",
	"~/.bash_history",
	"~/.zsh_history"
];
const ALLOW_READ_DEFAULTS_COMMON = [
	"/tmp/",
	"/usr/",
	"/bin/",
	"/sbin/",
	"/etc/",
	"~/.gitlab/duo/",
	"~/.gitconfig",
	"~/.config/git/",
	"~/.nvm/",
	"~/.bun/",
	"~/.volta/"
];
const ALLOW_READ_DEFAULTS_MACOS = [
	"/private/tmp/",
	"/private/var/folders/",
	"/opt/homebrew/",
	"/Library/Frameworks/",
	"/System/Library/",
	"/Applications/"
];
function broadDenySupported() {
	return !(detectPlatform() === "macos" && isBunRuntime());
}
function getPlatformDefaults() {
	switch (detectPlatform()) {
		case "macos": return {
			allowRead: [...ALLOW_READ_DEFAULTS_COMMON, ...ALLOW_READ_DEFAULTS_MACOS],
			denyRead: broadDenySupported() ? ["/"] : []
		};
		case "linux": return {
			allowRead: [...ALLOW_READ_DEFAULTS_COMMON, "/snap/"],
			denyRead: ["/"]
		};
		default: return {
			allowRead: [...ALLOW_READ_DEFAULTS_COMMON],
			denyRead: []
		};
	}
}
const ALLOW_WRITE_DEFAULTS = ["/tmp"];
const MACOS_TMPDIR_WRITE_ALLOWLIST = [os.tmpdir()];
function getPlatformWriteDefaults() {
	return detectPlatform() === "macos" ? [...ALLOW_WRITE_DEFAULTS, ...MACOS_TMPDIR_WRITE_ALLOWLIST] : [...ALLOW_WRITE_DEFAULTS];
}
const DENY_WRITE_DEFAULTS = [
	".git/hooks/",
	".gitlab-ci.yml",
	".gitlab/",
	".gitconfig"
];
const MAX_CACHE_SIZE = 50;
let _DesktopSandboxConfig;
(class {
	static {
		[_DesktopSandboxConfig, _initClass$5] = _applyDecs$5(this, [Injectable(SandboxConfigService, [
			ConfigService,
			Logger,
			SandboxUserConfigLoader
		])], []).c;
	}
	#configService;
	#userConfigLoader;
	#logger;
	#instanceDomain;
	#configChangeDisposable;
	#mcpConfigCache = /* @__PURE__ */ new Map();
	constructor(configService, logger, userConfigLoader) {
		this.#configService = configService;
		this.#logger = withPrefix(logger, "[SandboxConfig]");
		this.#userConfigLoader = userConfigLoader;
		this.#instanceDomain = this.#extractInstanceDomain();
		this.#configChangeDisposable = this.#configService.onConfigChange(() => {
			this.refresh();
		});
	}
	getEffectiveWorkspaceConfig(workspacePath) {
		this.#logger.debug(`Building sandbox config for workspace: ${workspacePath}`);
		const platformDefaults = getPlatformDefaults();
		const baseAllowWrite = [workspacePath, ...getPlatformWriteDefaults()];
		const user = this.#userConfigLoader.getSnapshot().config;
		const userFs = user?.filesystem;
		const userNet = user?.network;
		const deniedDomains = this.#guardDeniedDomains(userNet?.deniedDomains ?? []);
		return {
			provider: "anthropic-sandbox-runtime",
			filesystem: {
				allowRead: [
					workspacePath,
					...platformDefaults.allowRead,
					...userFs?.allowRead ?? []
				],
				denyRead: [
					...platformDefaults.denyRead,
					...DENY_READ_DEFAULTS,
					...userFs?.denyRead ?? []
				],
				allowWrite: [...baseAllowWrite, ...userFs?.allowWrite ?? []],
				denyWrite: [...DENY_WRITE_DEFAULTS, ...this.#guardWriteDenies(userFs?.denyWrite ?? [], baseAllowWrite)]
			},
			network: {
				allowedDomains: [...this.#instanceDomain ? [this.#instanceDomain] : [], ...userNet?.allowedDomains ?? []],
				...deniedDomains.length ? { deniedDomains } : {}
			},
			enableWeakerNestedSandbox: user?.srt?.enableWeakerNestedSandbox,
			ignoreViolations: user?.srt?.ignoreViolations
		};
	}
	#guardWriteDenies(userDenies, baselineAllows) {
		return userDenies.filter((deny) => {
			const covered = baselineAllows.find((allow) => this.#covers(deny, allow));
			if (covered) {
				this.#logger.warn(`Ignoring user denyWrite "${deny}"; required for sandbox operation (covers "${covered}")`);
				return false;
			}
			return true;
		});
	}
	#guardDeniedDomains(userDenied) {
		const instance = this.#instanceDomain?.toLowerCase();
		if (!instance) return userDenied;
		return userDenied.filter((domain) => {
			const pattern = domain.trim().toLowerCase();
			if (pattern.startsWith("*.") ? instance.endsWith(`.${pattern.slice(2)}`) : instance === pattern) {
				this.#logger.warn(`Ignoring user deniedDomains "${domain}"; the GitLab instance ${this.#instanceDomain} must stay reachable`);
				return false;
			}
			return true;
		});
	}
	#covers(parent, child) {
		const norm = (p) => {
			let expanded = p;
			if (p === "~") expanded = os.homedir();
			else if (p.startsWith("~/")) expanded = path.join(os.homedir(), p.slice(2));
			return expanded.endsWith("/") ? expanded.slice(0, -1) : expanded;
		};
		const par = norm(parent);
		const ch = norm(child);
		return par === ch || ch.startsWith(`${par}/`);
	}
	getMcpServerConfig(workspacePath, serverName, overrides) {
		const cacheKey = `${workspacePath}:${serverName}`;
		if (!overrides) {
			const cached = this.#mcpConfigCache.get(cacheKey);
			if (cached) return this.#deepCopy(cached);
		}
		const base = this.getEffectiveWorkspaceConfig(workspacePath);
		if (!overrides) {
			this.#cacheConfig(cacheKey, base);
			return base;
		}
		const config = this.#deepCopy(base);
		if (overrides.allowedDomains?.length) config.network.allowedDomains = [...config.network.allowedDomains, ...overrides.allowedDomains];
		if (overrides.allowRead?.length) config.filesystem.allowRead = [...config.filesystem.allowRead ?? [], ...overrides.allowRead];
		if (overrides.allowWrite?.length) config.filesystem.allowWrite = [...config.filesystem.allowWrite, ...overrides.allowWrite];
		if (overrides.denyRead?.length) config.filesystem.denyRead = [...config.filesystem.denyRead, ...overrides.denyRead];
		return config;
	}
	refresh() {
		this.#instanceDomain = this.#extractInstanceDomain();
		this.#mcpConfigCache.clear();
		this.#logger.debug(`Refreshed sandbox config, instanceDomain=${this.#instanceDomain ?? "none"}`);
	}
	dispose() {
		this.#configChangeDisposable?.dispose();
		this.#mcpConfigCache.clear();
	}
	#extractInstanceDomain() {
		const baseUrl = this.#configService.get("baseUrl");
		if (!baseUrl) return;
		try {
			return new URL(baseUrl).hostname;
		} catch {
			this.#logger.warn(`Failed to parse baseUrl: ${baseUrl}`);
			return;
		}
	}
	#cacheConfig(key, config) {
		if (this.#mcpConfigCache.size >= MAX_CACHE_SIZE) {
			const oldestKey = this.#mcpConfigCache.keys().next().value;
			if (oldestKey) this.#mcpConfigCache.delete(oldestKey);
		}
		this.#mcpConfigCache.set(key, this.#deepCopy(config));
	}
	#deepCopy(obj) {
		return JSON.parse(JSON.stringify(obj));
	}
	static {
		_initClass$5();
	}
});
//#endregion
//#region src/providers/sandbox_provider.ts
/**
* How to spawn a sandboxed command. `shell` carries a single wrapped
* command string spawned through a shell; `argv` carries a binary plus args
* spawned directly. Discriminated so quoting and spawn semantics are
* type-scoped to the variant that needs them. `env` is the environment the
* caller should spawn the child with; `undefined` means the caller should
* apply its own default (e.g. the worker's own env, or the MCP transport's).
*/
/**
* Translates an agnostic sandbox policy into a sandboxed command for one
* provider. The caller computes the policy and spawns the returned invocation;
* the provider owns only the translation. `env` is routed through so the
* provider is the single place the child's environment can be scrubbed or
* augmented; the returned `env` may drop keys the input carried.
*/
const SandboxProvider = createInterfaceId("SandboxProvider");
//#endregion
//#region src/desktop_mcp_stdio_sandbox_wrapper.ts
let _initClass$4;
function _applyDecs$4(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$4(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$4(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$4(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$4(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$4(t) {
	var i = _toPrimitive$4(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$4(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$4(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$4(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DesktopMcpStdioSandb;
(class {
	static {
		[_DesktopMcpStdioSandb, _initClass$4] = _applyDecs$4(this, [Injectable(McpStdioCommandTransformer, [
			SandboxAvailabilityService,
			SandboxConfigService,
			ConfigService,
			SandboxProvider,
			Logger
		])], []).c;
	}
	#sandboxAvailability;
	#sandboxConfig;
	#configService;
	#provider;
	#logger;
	constructor(sandboxAvailability, sandboxConfig, configService, provider, logger) {
		this.#sandboxAvailability = sandboxAvailability;
		this.#sandboxConfig = sandboxConfig;
		this.#configService = configService;
		this.#provider = provider;
		this.#logger = withPrefix(logger, "[McpSandboxWrapper]");
	}
	async transform(serverName, params, workspacePath, overrides) {
		if (!(this.#configService.get("duo.sandbox.enabled") ?? false)) return params;
		if (overrides?.sandboxEnabled === false) {
			this.#logger.debug(`Sandbox disabled for server "${serverName}" via config`);
			return params;
		}
		const status = this.#sandboxAvailability.getStatus();
		if (!status.available) throw new SandboxUnavailableError(`Sandbox is enabled but sandbox provider is not available (${status.reason}). Either install provider dependencies or disable sandboxing for server "${serverName}" with "sandbox": { "sandboxEnabled": false }.`, status.reason);
		const sandboxConfig = this.#sandboxConfig.getMcpServerConfig(workspacePath, serverName, overrides);
		const invocation = await this.#provider.wrapCommand(params.command, params.args, params.env, sandboxConfig);
		this.#logger.info(`Wrapping MCP server "${serverName}" (provider=${this.#provider.id}, kind=${invocation.kind})`);
		const env = stripUndefinedEnv(invocation.env ?? params.env);
		if (invocation.kind === "shell") return {
			command: "/bin/sh",
			args: ["-c", invocation.command],
			env
		};
		return {
			command: invocation.command,
			args: invocation.args,
			env
		};
	}
	static {
		_initClass$4();
	}
});
function stripUndefinedEnv(env) {
	if (env === void 0) return void 0;
	return Object.fromEntries(Object.entries(env).filter((entry) => entry[1] !== void 0));
}
//#endregion
//#region src/shell_quote.ts
function shellQuote(s) {
	return `'${s.replace(/'/g, "'\\''")}'`;
}
//#endregion
//#region src/worker_process_manager.ts
let _initClass$3;
function _applyDecs$3(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$3(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$3(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$3(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$3(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$3(t) {
	var i = _toPrimitive$3(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$3(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$3(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$3(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const EMBEDDED_WORKER_FLAG = Symbol.for("gitlab.lsp.embedded-sandbox-worker");
function isEmbeddedWorkerAvailable() {
	return globalThis[EMBEDDED_WORKER_FLAG] === true;
}
const CRASH_RESET_MS = 6e4;
const MAX_CRASH_COUNT = 3;
const WORKER_READY_TIMEOUT_MS = 3e4;
const WorkerProcessManager = createInterfaceId("WorkerProcessManager");
let _DefaultWorkerProcess;
(class {
	static {
		[_DefaultWorkerProcess, _initClass$3] = _applyDecs$3(this, [Injectable(WorkerProcessManager, [
			Logger,
			SandboxAvailabilityService,
			SandboxConfigService,
			SecretRedactor,
			SandboxProvider
		])], []).c;
	}
	#logger;
	#sandboxAvailability;
	#sandboxConfig;
	#secretRedactor;
	#provider;
	#process = null;
	#connection = null;
	#readyPromise = null;
	#currentWorkspacePath = null;
	#sandboxedCommand = null;
	#crashCount = 0;
	#lastCrashTime = 0;
	constructor(logger, sandboxAvailability, sandboxConfig, secretRedactor, provider) {
		this.#logger = withPrefix(logger, "[WorkerProcessManager]");
		this.#sandboxAvailability = sandboxAvailability;
		this.#sandboxConfig = sandboxConfig;
		this.#secretRedactor = secretRedactor;
		this.#provider = provider;
	}
	async ensureRunning(workspacePath) {
		if (this.#connection && this.isRunning() && this.#currentWorkspacePath === workspacePath) return this.#connection;
		if (this.isRunning() && this.#currentWorkspacePath !== workspacePath) {
			this.#logger.info("Workspace changed, respawning worker");
			this.shutdown();
		}
		if (this.#readyPromise) {
			await this.#readyPromise;
			if (!this.#connection) throw new Error("Worker failed to initialize");
			return this.#connection;
		}
		this.#currentWorkspacePath = workspacePath;
		this.#readyPromise = this.#spawnWorker(workspacePath);
		try {
			await this.#readyPromise;
		} catch (error) {
			this.#readyPromise = null;
			throw error;
		}
		if (!this.#connection) throw new Error("Worker failed to initialize");
		return this.#connection;
	}
	shutdown() {
		if (this.#connection) try {
			this.#connection.sendNotification(WorkerShutdownNotification.methodName).catch((error) => {
				this.#logger.debug("Failed to send shutdown notification", error);
			});
			this.#connection.dispose();
		} catch (error) {
			this.#logger.debug("Shutdown cleanup failed", error);
		}
		if (this.#process && !this.#process.killed) this.#process.kill("SIGTERM");
		this.#connection = null;
		this.#process = null;
		this.#readyPromise = null;
		this.#currentWorkspacePath = null;
		this.#sandboxedCommand = null;
	}
	dispose() {
		this.shutdown();
	}
	isRunning() {
		return this.#process !== null && this.#process.exitCode === null;
	}
	getSandboxedCommand() {
		return this.#sandboxedCommand;
	}
	async #spawnWorker(workspacePath) {
		this.#checkCrashThreshold();
		const { command: baseCommand, args: baseArgs } = this.#resolveWorkerScript();
		const sandboxStatus = this.#sandboxAvailability.getStatus();
		const workerEnv = {
			...process.env,
			GITLAB_SANDBOX_WORKER: "true"
		};
		let command;
		let args;
		let useShell;
		let spawnEnv;
		if (sandboxStatus.available) {
			const config = this.#sandboxConfig.getEffectiveWorkspaceConfig(workspacePath);
			const workerScriptDirs = [baseCommand, ...baseArgs].map(dirname).filter((d) => d !== "" && d !== "." && d !== "/");
			const policy = {
				...config,
				filesystem: {
					...config.filesystem,
					allowRead: [...config.filesystem.allowRead ?? [], ...workerScriptDirs]
				}
			};
			const invocation = await this.#provider.wrapCommand(baseCommand, baseArgs, workerEnv, policy);
			this.#sandboxedCommand = [baseCommand, ...baseArgs].map(shellQuote).join(" ");
			this.#logger.info(`Spawning sandboxed worker (provider=${this.#provider.id}, kind=${invocation.kind})`);
			spawnEnv = {
				...invocation.env ?? workerEnv,
				GITLAB_SANDBOX_WORKER: "true"
			};
			if (invocation.kind === "shell") {
				command = invocation.command;
				args = [];
				useShell = true;
			} else {
				command = invocation.command;
				args = invocation.args;
				useShell = false;
			}
		} else {
			this.#logger.info(`Spawning unsandboxed worker (reason: ${sandboxStatus.reason})`);
			command = baseCommand;
			args = baseArgs;
			useShell = false;
			spawnEnv = workerEnv;
		}
		const workerProcess = spawn(command, args, {
			stdio: [
				"pipe",
				"pipe",
				"pipe"
			],
			cwd: workspacePath,
			shell: useShell,
			env: spawnEnv
		});
		this.#process = workerProcess;
		if (!workerProcess.stdout || !workerProcess.stdin) throw new Error("Failed to create worker process stdio");
		const maxStderrLines = 200;
		const maxStderrBuffer = 1024 * 1024;
		let stderrBuffer = "";
		workerProcess.stderr?.on("data", (chunk) => {
			stderrBuffer += chunk.toString();
			if (stderrBuffer.length > maxStderrBuffer) {
				const truncated = stderrBuffer.split("\n").slice(-maxStderrLines);
				this.#logger.warn(`[worker stderr] Buffer exceeded ${maxStderrBuffer} bytes, keeping last ${truncated.length} lines`);
				for (const line of truncated) if (line.trim()) this.#logger.warn(`[worker stderr] ${this.#secretRedactor.redactSecrets(line, "worker-stderr")}`);
				stderrBuffer = "";
				return;
			}
			const lines = stderrBuffer.split("\n");
			stderrBuffer = lines.pop() || "";
			for (const line of lines) if (line.trim()) this.#logger.warn(`[worker stderr] ${this.#secretRedactor.redactSecrets(line, "worker-stderr")}`);
		});
		workerProcess.on("exit", () => {
			if (stderrBuffer.trim()) this.#logger.warn(`[worker stderr] ${this.#secretRedactor.redactSecrets(stderrBuffer, "worker-stderr")}`);
		});
		const connection = createMessageConnection(new StreamMessageReader(workerProcess.stdout), new StreamMessageWriter(workerProcess.stdin));
		this.#connection = connection;
		return new Promise((resolve, reject) => {
			let settled = false;
			const timeout = setTimeout(() => {
				if (settled) return;
				settled = true;
				this.shutdown();
				reject(/* @__PURE__ */ new Error("Worker failed to signal ready within timeout"));
			}, WORKER_READY_TIMEOUT_MS);
			const cleanup = (error) => {
				if (settled) return;
				settled = true;
				clearTimeout(timeout);
				this.shutdown();
				reject(error);
			};
			connection.onNotification(WorkerReadyNotification.methodName, () => {
				if (settled) return;
				settled = true;
				clearTimeout(timeout);
				this.#logger.info("Worker ready");
				resolve();
			});
			workerProcess.on("error", (error) => {
				this.#logger.error("Worker process error", error);
				cleanup(error);
			});
			workerProcess.on("exit", (code, signal) => {
				this.#logger.info(`Worker exited: code=${code}, signal=${signal}`);
				this.#handleExit(code, signal);
				if (!settled) cleanup(/* @__PURE__ */ new Error(`Worker exited before ready: code=${code}, signal=${signal}`));
			});
			connection.listen();
		});
	}
	#resolveWorkerScript() {
		const mainScript = __require.main?.filename ?? process.argv[1];
		if (mainScript) {
			const bundledJs = join(dirname(mainScript), "sandbox_worker.js");
			if (existsSync(bundledJs)) return {
				command: process.execPath,
				args: [bundledJs]
			};
		}
		if (isEmbeddedWorkerAvailable()) return {
			command: process.execPath,
			args: []
		};
		const workerModule = ["./worker", "worker_main"].join("/");
		return {
			command: process.execPath,
			args: [__require.resolve(workerModule)]
		};
	}
	#handleExit(code, signal) {
		try {
			this.#connection?.dispose();
		} catch {}
		this.#connection = null;
		this.#process = null;
		this.#readyPromise = null;
		this.#sandboxedCommand = null;
		if (code !== 0 && signal !== "SIGTERM") this.#recordCrash();
	}
	#recordCrash() {
		const now = Date.now();
		if (now - this.#lastCrashTime > CRASH_RESET_MS) this.#crashCount = 0;
		this.#crashCount++;
		this.#lastCrashTime = now;
		this.#logger.warn(`Worker crash recorded (${this.#crashCount}/${MAX_CRASH_COUNT})`);
	}
	#checkCrashThreshold() {
		if (this.#crashCount >= MAX_CRASH_COUNT) throw new Error(`Worker crashed ${MAX_CRASH_COUNT} times within ${CRASH_RESET_MS}ms. Refusing to restart.`);
	}
	static {
		_initClass$3();
	}
});
//#endregion
//#region src/providers/srt_sandbox_provider.ts
let _initClass$2;
function _applyDecs$2(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$2(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$2(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$2(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$2(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$2(t) {
	var i = _toPrimitive$2(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$2(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$2(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$2(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Anthropic Sandbox Runtime provider. Bundled SDK-backed implementation: keeps
* the runtime in the binary and wraps the worker command via the SDK. Stateless;
* `SandboxManager.initialize()` is process-global (first-call-wins), so the
* provider holds no resource to dispose.
*/
let _SrtSandboxProvider;
(class {
	static {
		[_SrtSandboxProvider, _initClass$2] = _applyDecs$2(this, [Injectable(SandboxProvider, [])], []).c;
	}
	id = "anthropic-sandbox-runtime";
	async wrapCommand(command, args, env, policy) {
		if (policy.provider !== "anthropic-sandbox-runtime") throw new Error(`SrtSandboxProvider received an unsupported policy provider '${policy.provider}'; expected 'anthropic-sandbox-runtime'.`);
		const config = policy;
		const runtimeConfig = {
			network: {
				allowedDomains: config.network.allowedDomains,
				deniedDomains: config.network.deniedDomains ?? []
			},
			filesystem: {
				allowRead: config.filesystem.allowRead ?? [],
				denyRead: config.filesystem.denyRead,
				allowWrite: config.filesystem.allowWrite,
				denyWrite: config.filesystem.denyWrite
			},
			ignoreViolations: config.ignoreViolations,
			enableWeakerNestedSandbox: config.enableWeakerNestedSandbox,
			enableWeakerNetworkIsolation: config.enableWeakerNetworkIsolation
		};
		await SandboxManager.initialize(runtimeConfig, void 0, true);
		const sandboxedCmd = [command, ...args].map(shellQuote).join(" ");
		return {
			kind: "shell",
			command: await SandboxManager.wrapWithSandbox(sandboxedCmd, void 0, runtimeConfig),
			env
		};
	}
	static {
		_initClass$2();
	}
});
//#endregion
//#region src/sandboxed_action_executor.ts
const workerMessageDefinitions = { getMessageDefinitions: () => [ExecuteActionRequest, CancelActionNotification] };
var SandboxedActionExecutor = class {
	#workerManager;
	#sandboxViolations;
	#logger;
	constructor(workerManager, sandboxViolations, logger) {
		this.#workerManager = workerManager;
		this.#sandboxViolations = sandboxViolations;
		this.#logger = withPrefix(logger, "[SandboxedActionExecutor]");
	}
	async execute(action, context) {
		try {
			const sender = new DefaultRpcMessageSender(await this.#workerManager.ensureRunning(context.workspaceFolderPath), workerMessageDefinitions);
			const workerContext = {
				workspaceFolderPath: context.workspaceFolderPath,
				workspaceFolderUri: context.workspaceFolderUri,
				workflowId: context.workflowId,
				gitlabBaseUrl: context.workflowToken.gitlab_rails.base_url,
				gitlabToken: context.workflowToken.gitlab_rails.token
			};
			const abortHandler = () => {
				sender.send(CancelActionNotification, { requestID: action.requestID }).catch((err) => {
					this.#logger.debug("Failed to send cancel notification", err);
				});
			};
			context.abortSignal.addEventListener("abort", abortHandler);
			try {
				const startMs = Date.now();
				const response = await sender.send(ExecuteActionRequest, {
					action,
					context: workerContext
				});
				if ("error" in response && response.error) {
					const sandboxError = renderViolation(this.#sandboxViolations, startMs, response.error, this.#logger, this.#workerManager.getSandboxedCommand() ?? void 0);
					if (sandboxError) return {
						...response,
						error: sandboxError
					};
				}
				return response;
			} finally {
				context.abortSignal.removeEventListener("abort", abortHandler);
			}
		} catch (err) {
			const error = err instanceof Error ? err.message : String(err);
			this.#logger.error(`Action execution failed: ${error}`);
			return {
				response: "",
				error
			};
		}
	}
	dispose() {
		this.#workerManager.shutdown();
	}
};
//#endregion
//#region src/sandbox_aware_action_executor_factory.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _SandboxAwareActionEx;
(class {
	static {
		[_SandboxAwareActionEx, _initClass$1] = _applyDecs$1(this, [Injectable(ActionExecutorFactory, [
			Logger,
			collection(WorkflowActionHandler),
			SandboxAvailabilityService,
			WorkerProcessManager,
			ConfigService,
			SandboxViolations
		])], []).c;
	}
	#logger;
	#directExecutor;
	#sandboxAvailability;
	#workerManager;
	#configService;
	#sandboxViolations;
	constructor(logger, handlers, sandboxAvailability, workerManager, configService, sandboxViolations) {
		this.#logger = withPrefix(logger, "[ActionExecutorFactory]");
		this.#directExecutor = new DirectActionExecutor(handlers, logger);
		this.#sandboxAvailability = sandboxAvailability;
		this.#workerManager = workerManager;
		this.#configService = configService;
		this.#sandboxViolations = sandboxViolations;
	}
	createExecutor() {
		if (!(this.#configService.get("duo.sandbox.enabled") ?? false)) {
			this.#logger.debug("Returning DirectActionExecutor (sandbox not enabled)");
			return this.#directExecutor;
		}
		const status = this.#sandboxAvailability.getStatus();
		if (!status.available) throw new SandboxUnavailableError(`Sandbox is enabled but sandbox provider is not available (${status.reason}).`, status.reason);
		this.#logger.debug("Creating SandboxedActionExecutor");
		return new SandboxedActionExecutor(this.#workerManager, this.#sandboxViolations, this.#logger);
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/violations/desktop_sandbox_violations.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
function mapAndFilter(events, startMs) {
	return events.filter((v) => v.timestamp.getTime() >= startMs).map((v) => ({
		description: v.line,
		timestamp: v.timestamp
	}));
}
let _DesktopSandboxViolat;
(class {
	static {
		[_DesktopSandboxViolat, _initClass] = _applyDecs(this, [Injectable(SandboxViolations, [])], []).c;
	}
	getSince(startMs) {
		return mapAndFilter(SandboxManager.getSandboxViolationStore().getViolations(), startMs);
	}
	getForCommandSince(command, startMs) {
		return mapAndFilter(SandboxManager.getSandboxViolationStore().getViolationsForCommand(command), startMs);
	}
	static {
		_initClass();
	}
});
//#endregion
export { CancelActionNotification, _DefaultSandboxDisabl as DefaultSandboxDisabledByUserCheck, _DefaultSandboxMissin as DefaultSandboxMissingDependenciesCheck, _DefaultSandboxUnsupp as DefaultSandboxUnsupportedPlatformCheck, _DefaultWorkerProcess as DefaultWorkerProcessManager, _DesktopMcpStdioSandb as DesktopMcpStdioSandboxWrapper, _DesktopSandboxAvaila as DesktopSandboxAvailabilityService, _DesktopSandboxConfig as DesktopSandboxConfigService, _DesktopSandboxViolat as DesktopSandboxViolations, _EmptySandboxAvailabi as EmptySandboxAvailabilityService, ExecuteActionRequest, HttpResponseSchema, PlainTextResponseSchema, SandboxAvailabilityService, _SandboxAwareActionEx as SandboxAwareActionExecutorFactory, SandboxConfigService, SandboxDisabledByUserCheck, SandboxMissingDependenciesCheck, SandboxProvider, SandboxUnsupportedPlatformCheck, SandboxedActionExecutor, _SrtSandboxProvider as SrtSandboxProvider, WorkerActionRequestSchema, WorkerActionResponseSchema, WorkerContextSchema, WorkerProcessManager, WorkerReadyNotification, WorkerShutdownNotification, sandboxFeatureStateContributions };

//# sourceMappingURL=index.mjs.map